export const environment = {
  production: true
};

export const baseUrl = 'https://api.vsing.my'
